import React from "react";
import "./ReportTemplateContent.css";

function ReportTemplateContent(props) {
  return (
    <div className="h100 w100" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
      <div
        className="reportTemplateHtmlContent"
        dangerouslySetInnerHTML={{ __html: props.htmlContent }}
      ></div>
    </div>
  );
}

export default ReportTemplateContent;
